/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import {
  GROUP_ADD_ACTION_TYPES,
  SELECTED_CLIENT_ACTION_TYPES,
  MAINTIN_GROUP_DETAILS_ACTION_TYPES,
  CLIENT_ID_DROPDOWN_ACTION_TYPES,
  CLIENT_DATA_ACTION_TYPES,
  MAINTAIN_GROUP_CONTACT_ACTION_TYPES,
  MAINTAIN_GROUP_PARTICIPATION_DATES_ACTION_TYPES,
  MAINTAIN_GROUP_PLANS_ACTION_TYPES,
  GET_CONTACT_TYPE,
  GET_EXISTING_CONTACT_DETAILS,
  NAVIGATION_LISTENER_ACTION_TYPES,
  GET_CONTACT_DETAILS,
  ERROR_POPUP_ACTION_TYPES,
  UPDATE_CONTACT_DETAILS,
  MAINTAIN_GROUP_COMPARE_DATA,
  GROUP_DATA_CHANGE_TRIED,
  COMPARE_GROUP_CONTACT_INFO,
  SAVE_OR_FAIL_RES,
  GROUP_TAB_DATA,
  SET_SELECTED_GROUP,
  SET_CLEAR_REDUX_DATA,
  CREATE_NEW_GRP_OPT,
  CLEAR_SAVE_OR_FAIL_RES
} from './group-action-types';

const intialState = {
  searchScreen: {
    state: {
      selectedClient: 'Group',
    },
  },
  clientData: [],

  // Maintain Group
  mainGroupDetails: null,

  clientIdDropdown: [],
  groupAdd: true,
  particpationDates: [],
  compareData: { details: null, data: [] },
  plans: [],
  contact: null,

  allContactTypeDropDown: [],
  existingContactDetails: [],
  contactDetails: {},
  compareContactDetails: {},
  updateOrSaveContactDetailsMessage: '',
  navigationListener: null,
  errorPopup: null,
  dataChangeTried: 0,
  groupTabData: null,
  selectedGroup: null,
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case ERROR_POPUP_ACTION_TYPES:
      return {
        ...state,
        errorPopup: action.payload,
      };
    case NAVIGATION_LISTENER_ACTION_TYPES:
      return {
        ...state,
        navigationListener: action.payload,
      };
    case GET_CONTACT_TYPE:
      return {
        ...state,
        allContactTypeDropDown: action.allContactTypeDropDown,
      };
    case GET_EXISTING_CONTACT_DETAILS:
      return {
        ...state,
        existingContactDetails: action.existingContactDetails,
      };
    case GET_CONTACT_DETAILS:
      return { ...state, contactDetails: action.contactDetails };
    case UPDATE_CONTACT_DETAILS:
      return {
        ...state,
        updateOrSaveContactDetailsMessage:
          action.updateOrSaveContactDetailsMessage,
      };
    case SELECTED_CLIENT_ACTION_TYPES:
      return { ...state, searchScreen: action.payload };
    case CLIENT_DATA_ACTION_TYPES:
      return { ...state, clientData: action.payload };
    case MAINTIN_GROUP_DETAILS_ACTION_TYPES:
      return { ...state, mainGroupDetails: action.payload };
    case MAINTAIN_GROUP_COMPARE_DATA:
      return { ...state, compareData: action.payload };
    case CLIENT_ID_DROPDOWN_ACTION_TYPES:
      return { ...state, clientIdDropdown: action.payload };
    case GROUP_ADD_ACTION_TYPES:
      return { ...state, groupAdd: action.payload };
    case MAINTAIN_GROUP_PARTICIPATION_DATES_ACTION_TYPES:
      action.payload.forEach((item, i) => {
        item.index = i;
        item.startDt = item.clientGroupId.startDt;
      });
      return { ...state, particpationDates: action.payload };
    case CREATE_NEW_GRP_OPT:
      return { ...state, createfirst: action.payload };
    case MAINTAIN_GROUP_PLANS_ACTION_TYPES:
      return { ...state, plans: action.payload };
    case MAINTAIN_GROUP_CONTACT_ACTION_TYPES:
      return { ...state, contact: action.payload };
    case GROUP_DATA_CHANGE_TRIED:
      return { ...state, dataChangeTried: action.payload };
    case COMPARE_GROUP_CONTACT_INFO:
      return { ...state, compareContactDetails: action.payload };
    case SAVE_OR_FAIL_RES:
      return { ...state, saveOrFailRes: action.payload };
    case CLEAR_SAVE_OR_FAIL_RES:
      return { ...state, saveOrFailRes: {}};
    case GROUP_TAB_DATA:
      return { ...state, groupTabData: action.payload };
    case SET_SELECTED_GROUP:
      return { ...state, selectedGroup: action.payload };
    case SET_CLEAR_REDUX_DATA:
      return { ...intialState };
    default:
      return state;
  }
};

export default reducer;
